"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlideIdentifier = exports.ColumnType = exports.Operator = exports.DeckType = void 0;
var DeckType;
(function (DeckType) {
    DeckType["GENERATED"] = "GENERATED";
    DeckType["STATIC"] = "STATIC";
})(DeckType || (exports.DeckType = DeckType = {}));
var Operator;
(function (Operator) {
    Operator["GREATER_THAN"] = ">";
    Operator["GREATER_THAN_EQUAL"] = ">=";
    Operator["LESS_THAN"] = "<";
    Operator["LESS_THAN_EQUAL"] = "<=";
    Operator["EQUAL"] = "=";
    Operator["LIKE"] = "LIKE";
})(Operator || (exports.Operator = Operator = {}));
var ColumnType;
(function (ColumnType) {
    ColumnType["STRING"] = "STRING";
    ColumnType["NUMBER"] = "NUMBER";
})(ColumnType || (exports.ColumnType = ColumnType = {}));
var SlideIdentifier;
(function (SlideIdentifier) {
    SlideIdentifier["HardwareAndSoftware"] = "HardwareAndSoftware";
    SlideIdentifier["AssetReviewBar"] = "AssetReviewBar";
    SlideIdentifier["AssetReviewDoughnut"] = "AssetReviewDoughnut";
    SlideIdentifier["PurityCodeLevels"] = "PurityCodeLevels";
    SlideIdentifier["PurityAdoptionRatesFlasharray"] = "PurityAdoptionRatesFlasharray";
    SlideIdentifier["PurityAdoptionRatesFlashblade"] = "PurityAdoptionRatesFlashblade";
    SlideIdentifier["FeatureAdoptionAutomationAndFaFeatures"] = "FeatureAdoptionAutomationAndFaFeatures";
    SlideIdentifier["FeatureAdoptionPure1AndFbFeatures"] = "FeatureAdoptionPure1AndFbFeatures";
    SlideIdentifier["CapacityPlanning"] = "CapacityPlanning";
    SlideIdentifier["CapacityReviewFlasharray"] = "CapacityReviewFlasharray";
    SlideIdentifier["CapacityReviewFlashblade"] = "CapacityReviewFlashblade";
    SlideIdentifier["CapacityProjection"] = "CapacityProjection";
    SlideIdentifier["DataReductionFlasharray"] = "DataReductionFlasharray";
    SlideIdentifier["DataReductionFlashblade"] = "DataReductionFlashblade";
    SlideIdentifier["PaasSubscriptions"] = "PaasSubscriptions";
    SlideIdentifier["PerformanceReview"] = "PerformanceReview";
    SlideIdentifier["HeatMap"] = "HeatMap";
    SlideIdentifier["LoadFlasharrayTop10Maximum"] = "LoadFlasharrayTop10Maximum";
    SlideIdentifier["LoadFlasharrayTop10Average"] = "LoadFlasharrayTop10Average";
    SlideIdentifier["FlasharrayTop5"] = "FlasharrayTop5";
    SlideIdentifier["FlashbladeTop5"] = "FlashbladeTop5";
    SlideIdentifier["SupportReview"] = "SupportReview";
    SlideIdentifier["OpenSupportCasesFlashArray"] = "OpenSupportCasesFlashArray";
    SlideIdentifier["OpenSupportCasesFlashBlade"] = "OpenSupportCasesFlashBlade";
    SlideIdentifier["ClosedSupportCasesFlashArray30DaysLookBack"] = "ClosedSupportCasesFlashArray30DaysLookBack";
    SlideIdentifier["ClosedSupportCasesFlashBlade30DaysLookBack"] = "ClosedSupportCasesFlashBlade30DaysLookBack";
    SlideIdentifier["PartsReplacementFlashArray30DaysLookBack"] = "PartsReplacementFlashArray30DaysLookBack";
    SlideIdentifier["PartsReplacementFlashBlade30DaysLookBack"] = "PartsReplacementFlashBlade30DaysLookBack";
    SlideIdentifier["FleetReview"] = "FleetReview";
    SlideIdentifier["MaintenanceEndDates"] = "MaintenanceEndDates";
    SlideIdentifier["FleetReviewFlashArray"] = "FleetReviewFlashArray";
    SlideIdentifier["FleetReviewFlashBlade"] = "FleetReviewFlashBlade";
    SlideIdentifier["RmaDataOverTime"] = "RmaDataOverTime";
    SlideIdentifier["PartsReplacedWithDispatchStatus"] = "PartsReplacedWithDispatchStatus";
    SlideIdentifier["UninstalledArrays"] = "DummyArrays";
    SlideIdentifier["UninstalledArraysWithMarketingSku"] = "DummyArraysWithMarketingSkew";
    SlideIdentifier["InstalledVsUninstalledArrays"] = "InstalledVsDummyArrays";
    SlideIdentifier["FeatureAdoptionBase"] = "FeatureAdoptionBase";
    SlideIdentifier["FeatureAdoption"] = "FeatureAdoption";
    SlideIdentifier["FeatureAdoptionFB"] = "FeatureAdoptionFB";
    SlideIdentifier["FeatureAdoptionPure1"] = "FeatureAdoptionPure1";
    SlideIdentifier["EnvironmentReview"] = "EnvironmentReview";
    SlideIdentifier["KeyMetrics"] = "KeyMetrics";
    SlideIdentifier["SystemCurrency"] = "SystemCurrency";
    SlideIdentifier["FleetDetail"] = "FleetDetail";
    SlideIdentifier["CaseDetail"] = "CaseDetail";
    SlideIdentifier["ProtectionInsights"] = "ProtectionInsights";
    SlideIdentifier["CustomerValueDelivered"] = "CustomerValueDelivered";
    SlideIdentifier["RtcoCustomerSpend"] = "RtcoCustomerSpend";
    SlideIdentifier["RtcoShippedCapacityGrowth"] = "RtcoShippedCapacityGrowth";
    SlideIdentifier["ArrayUpgradeRecommendations"] = "ArrayUpgradeRecommendations";
    SlideIdentifier["ProposalDataSummary"] = "ProposalDataSummary";
    SlideIdentifier["ProposalDataWeeklyCPULoad"] = "ProposalDataWeeklyCPULoad";
    SlideIdentifier["ProposalDataArrayList"] = "ProposalDataArrayList";
    SlideIdentifier["ContactInformation"] = "ContactInformation";
    SlideIdentifier["ContactInformationVerification"] = "ContactInformationVerification";
    SlideIdentifier["PureSolutionUpdate"] = "PureSolutionUpdate";
    SlideIdentifier["Faxl"] = "faxl";
    SlideIdentifier["Ransomware"] = "Ransomware";
    SlideIdentifier["Anomalies"] = "Anomalies";
    SlideIdentifier["AnomoliesDetected"] = "AnomoliesDetected";
    SlideIdentifier["CaseTrending"] = "CaseTrending";
    SlideIdentifier["CaseGenerationByQuarter"] = "CaseGenerationByQuarter";
    SlideIdentifier["TicketsPerInstalledArrayQoq"] = "TicketsPerInstalledArrayQoq";
    SlideIdentifier["M2X"] = "M2X";
    SlideIdentifier["DataProtection"] = "DataProtection";
    SlideIdentifier["DataProtectionAssessment"] = "DataProtectionAssessment";
    SlideIdentifier["FaFiles"] = "FaFiles";
})(SlideIdentifier || (exports.SlideIdentifier = SlideIdentifier = {}));
//# sourceMappingURL=PptxConfiguration.js.map